import React, { useState } from "react";
import CurrentPlayersTable from "./Tables/CurrentPlayersTable";
import AddToCurrentPlayersField from "./Fields/AddToCurrentPlayersField";
import CurrentPlayersModal from "./Modals/CurPlayersModal";

interface GameInfo {
  id: string;
  [key: string]: any;
}

interface CurrentPlayersSectionProps {
  gameInfo: GameInfo;
  [key: string]: any;
}

const CurrentPlayersSection: React.FC<CurrentPlayersSectionProps> = (props) => {
  const [modalDets, setModalDets] = useState({
    open: false,
    status: "",
    reqData: {},
  });

  const { gameInfo } = props;
  const { currentPlayers, playerlist } = gameInfo;

  // Check if there are any players that are both in currentPlayers AND playerlist
  const hasActivePlayers = Object.keys(currentPlayers).some(playerId => 
    currentPlayers[playerId] && playerlist[playerId]
  );

  return (
    <div>
      {hasActivePlayers && <h2>CurrentPlayers</h2>}
      <CurrentPlayersModal dets={modalDets} gameInfo={props.gameInfo} />
      <AddToCurrentPlayersField setModalDets={setModalDets} {...props} />
      <CurrentPlayersTable setModalDets={setModalDets} {...props} />
    </div>
  );
};

export default CurrentPlayersSection;
